"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @author gnuni.gevorgyan
 */
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var LanguageImpl = /** @class */ (function (_super) {
    __extends(LanguageImpl, _super);
    function LanguageImpl(_id, _abbreviation, _isDefault, _direction, _charset, _name, _acronym, _isInput) {
        var _this = _super.call(this, _id, _name, _acronym, _direction) || this;
        _this._id = _id;
        _this._abbreviation = _abbreviation;
        _this._isDefault = _isDefault;
        _this._direction = _direction;
        _this._charset = _charset;
        _this._name = _name;
        _this._acronym = _acronym;
        _this._isInput = _isInput;
        return _this;
    }
    LanguageImpl.prototype.getIsInput = function () {
        return this._isInput;
    };
    LanguageImpl.prototype.getAbbreviation = function () {
        return this._abbreviation;
    };
    LanguageImpl.prototype.getIsDefault = function () {
        return this._isDefault;
    };
    LanguageImpl.prototype.getCharset = function () {
        return this._charset;
    };
    LanguageImpl.prototype.getAcronym = function () {
        return _super.prototype.getAcronym.call(this);
    };
    LanguageImpl.prototype.getDirection = function () {
        return _super.prototype.getDirection.call(this);
    };
    LanguageImpl.prototype.getName = function () {
        return _super.prototype.getName.call(this);
    };
    LanguageImpl.prototype.getId = function () {
        return _super.prototype.getId.call(this);
    };
    return LanguageImpl;
}(idm_crosscutting_concepts_frontend_1.Language));
exports.LanguageImpl = LanguageImpl;
//# sourceMappingURL=language-impl.js.map